module.exports = __webpack_public_path__ + "img/nat-turner.1cf62c38.png";